export default __webpack_public_path__ + "static/media/107_desktop.dc4c321d.jpg";